import Immutable from 'immutable';

export const MailingList = new Immutable.Record({
  listId: undefined,
  title: undefined,
  key: undefined,
});
